import { createGlobalStyle, css } from 'styled-components';

export const AgentGlobalResetStyles = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-bottom: 0;
  }
`;
export const AgentGlobalStyles = createGlobalStyle`
  body {
    [data-state="open"] {
      ${AgentGlobalResetStyles};
  }
 }
`;
